const myPlugin = {
    install: function (Vue, options) {
        Vue.filter('qType', function (value) {
            if (!value) return '';
            let txt = "";
            switch (value) {
                case "single":
                    // txt = "ตัวเลือกเดียว";
                    txt = "mdi-check-box-outline";
                    break;
                case "multiple":
                    // txt = "ตัวเลือกหลายข้อ";
                    txt = "mdi-check-box-multiple-outline";
                    break;
                case "matchsome":
                    // txt = "จับคู่";
                    txt = "mdi-shuffle";
                    break;
                case "fillgaptext":
                    // txt = "เติมคำ";
                    txt = "mdi-color-helper";
                    break;
                default:
                    break;
            }
            return txt;
        })

        Vue.filter('pureText', function (value, limit) {
            if (value != null) {
                let pureText = value.replace(/<[^>]*>/g, "");
                if (limit != null && pureText.length > limit) {
                    let dots = "...";
                    // you can also use substr instead of substring
                    pureText = pureText.substring(0, limit) + dots;
                }
                return pureText;
            }
            return "";
        })

        Vue.prototype.$hasAnswer = function (qType, value) {
            if (value != null && value != undefined) {
                let ret = false;
                const type = typeof (value);
                // console.log(type);

                if (type == "string" && value != "") {
                    ret = true;
                }
                else if (type == "number") {
                    ret = true;
                } else if (type == "object") {
                    try {
                        // check is is array
                        if (value.length > 0) {
                            ret = true;
                        }

                    } catch (error) {
                        // not array but is object and not null then true
                        ret = true;
                    }
                } else if (type == "array" && value.length > 0) {
                    ret = true;
                }
                else {
                    ret = false;
                }

                // special check
                if (qType == "matchsome") {
                    let empty = true;
                    for (let item of value) {
                        if (item.correct.length > 0) {
                            empty = false;
                            break;
                        }
                    }
                    ret = empty ? false : true;
                }

                return ret;
            }
            return false;
        }

        Vue.prototype.$answerChanged = function (type, userAnswer, newAnswer) {
            let changed = false;
            // console.log(userAnswer, newAnswer);
            switch (type) {
                case "multiple":
                    if (userAnswer.length != newAnswer.length) {
                        changed = true;
                    } else {
                        let matched = true;
                        for (let el of userAnswer) {
                            const exist = newAnswer.findIndex(x => x == el);
                            if (exist == -1) {
                                matched = false;
                                break;
                            }
                        }
                        changed = matched ? false : true;
                    }
                    break;
                case "single":
                    if (userAnswer[0] != newAnswer) {
                        changed = true;
                    }
                    break;
                case "fillgaptext":
                    if (userAnswer != newAnswer) {
                        changed = true;
                    }
                    break;
                case "matchsome":
                    // 1. check correct length of each left and dril down to check id
                    let matched = true;
                    if (userAnswer != null) {
                        for (const [idx, item] of userAnswer.entries()) {

                            // check length
                            if (item.correct.length != newAnswer[idx].correct.length) {
                                matched = false;
                                break;
                            }

                            // value check
                            for (let ans of item.correct) {
                                const exist = newAnswer[idx].correct.findIndex(x => x == ans);
                                if (exist == -1) {
                                    matched = false;
                                    break;
                                }
                            }
                        }
                        changed = matched ? false : true;
                    } else {
                        changed = false
                    }

                    break;

                default:
                    break;
            }
            return changed;
        }

        Vue.prototype.$matchsomeIsMatched = function (userAnswer, correctAnswer) {
            // console.log(userAnswer, correctAnswer);
            // 1. check correct length of each left and dril down to check id
            let matched = true;
            // check length
            if (userAnswer.length != correctAnswer.length) {
                matched = false;
            } else {
                // value check
                for (let ans of userAnswer) {
                    const exist = correctAnswer.findIndex(x => x._id == ans);
                    if (exist == -1) {
                        matched = false;
                        break;
                    }
                }
            }

            return matched;
        }

        Vue.prototype.$arrayShuffle = function (array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * i)
                const temp = array[i]
                array[i] = array[j]
                array[j] = temp
            }

            return array;
        }

        //#region  example

        // 1. add global method or property
        // Vue.myGlobalMethod = function () {
        //     // some logic ...
        // }

        // 2. add a global asset
        // Vue.directive('my-directive', {
        //     bind(el, binding, vnode, oldVnode) {
        //         // some logic ...
        //     }

        // })

        // 3. inject some component options
        // Vue.mixin({
        //   created: function () {
        //     // some logic ...
        //   }

        // })

        // 4. add an instance method
        // Vue.prototype.$myMethod = function (methodOptions) {
        //   // some logic ...
        // }

        //#endregion
    }
}

export default myPlugin;